<template>
    <div class="app-container pull-auto">
        <!--功能按钮组件页面-->
        <avue-crud :data="tableData" :option="tableOption" :page="page" @size-change="sizeChange" @current-change="currentChange" @search-reset="searchReset" @row-click="showRow" @search-change="searchChange">
            <template slot="search">
                <el-form-item label="工程信息">
                    <el-input placeholder="请输入工程名称或工程地址" v-model="form.condition" clearable></el-input>
                </el-form-item>
                <el-form-item label="工程状态">
                    <el-select v-model="form.state" placeholder="请选择" clearable>
                        <el-option  v-for="item in state" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </template>
            <template slot-scope="scope" slot="menuLeft">
                <el-button :disabled = "totalStatus" @click="userSee" size="mini" icon="el-icon-view" type="warning">查看详情</el-button>
                <el-button :disabled = "totalStatus" @click="cancelProject" size="mini" icon="el-icon-close" type="danger">取消项目</el-button>
            </template>
            <template slot-scope="scope" slot="projectId">
                <el-radio class="radio" v-model="radio"  :label="scope.row.projectId"></el-radio>
            </template>
        </avue-crud>
        <!--任务详情-->
        <orderinfo ref="child" @refresh="refresh"></orderinfo>
    </div>
</template>

<script>
    import {fetchList,deletOrder} from '@/api/admin/taskManagement'
    import {tableOption} from '@/const/asset/base/manufacturerinfo'
    import {mapGetters} from 'vuex'
    import { objKeySort } from '@/util/ajaxsign'
    import { dealElement } from '@/util/util'
    import orderinfo from '../orderinfo.vue'
    export default {
        name: 'manufacturerinfo',
         components: {orderinfo},
        data() {
            return {
                tableOption : tableOption,
                // 关闭原因
                closeReason:'',
                list: 0,
                total: 0,
                // listLoading: true,
                listQuery: {
                    current: 1,
                    size: 10,
                    total : 0,
                },
                // 搜索
                form: {
                    condition: '',
                    state:''
                },
                  state : [ { label : "未发布", value : "-1" },
                    { label : "正在招募", value : "0" },
                    { label : "等待执行", value : "1" },
                    { label : "项目取消", value : "2" },
                    // { label : "项目超时", value : "3" },
                    { label : "正在执行", value : "4" },
                    { label : "申请结项", value : "5" },
                    { label : "拒绝结项", value : "6" },
                    { label : "项目完结", value : "7" }
                ],
                stopFalse:{},
                dialogStop:false,
                dialogStart:false,
                radio:'',
                // 企业按钮开关
                companyTon:false,
                // 企业状态
                cSate:'',
                // 弹框开关
                //按钮禁用开关
                totalStatus:true,
                cancelStateus : true,
                add : false,
                // 状态
                companyId :'',
                tableData: [],
                page: {
                  pageSizes: [10, 20, 50, 100],
                  currentPage: 1,
                  total: 0,
                  pageSize: 10
                },

                tableLoading: false,
            }
        },
        created() {
            this.getList()
        },
        mounted: function () {
        },
        computed: {
            ...mapGetters(['permissions'])
        },
        methods: {
            //刷新列表操作
            refresh(data){
              if(data == "refresh"){
                this.getList()
              }
            },

            //创建项目
            handleCreate(){
                this.$router.push('/orderManager/addProject')
            },

            getSerialNumber(index) {
                return index + 1 + (this.listQuery.current - 1) * this.listQuery.size
            },
            // 查看当前企业信息
            userSee(){
              this.$refs.child.setsataus(this.radio,this.cancelStateus,true);
            },

            //删除项目
            cancelProject(){
              deletOrder(objKeySort({"projectId":this.radio})).then(response => {
                 this.getList();
                 this.totalStatus = true;
                 this.radio = undefined;
              })
            },

            showRow(row){
                this.radio = row.projectId;
                this.handleRowClick(row);
            },
            // 获取当前行数据
            handleRowClick (row) {
               this.cSate=row.state;
               //处理按钮
                if(row.state == 2){  //1
                    this.cancelStateus = false;
                }else{
                    this.cancelStateus = true;
                }
               this.totalStatus=false
            },
            // 提交搜索
            searchChange(){
                this.getList();
            },
            //清空收缩条件
            searchReset(){
              this.form={};
              this.listQuery.current = 1;
              this.listQuery.size = 10;
              this.getList();
            },
            getList() {
                this.tableLoading = true;
                this.totalStatus = true;
                this.radio = undefined;
                var data = {
                    pageNum: this.listQuery.current,
                    pageSize: this.listQuery.size,
                    state : this.form.state,
                    condition : this.form.condition
                }
                console.log(data)
                fetchList(objKeySort(dealElement(data))).then(response => {
                    this.tableData = response.data.data.rows;
                    this.page.total = response.data.data.total;
                    this.tableLoading = false;
                })
            },
            sizeChange(val) {
                this.listQuery.size = val;
                this.page.pageSize = val;
                this.listQuery.current = 1;
                this.getList()
            },
            currentChange(val) {
                this.listQuery.current = val;
                this.page.currentPage = val;
                this.getList()
            },
            /**
             * 刷新回调
             */
            refreshChange() {
                this.getList()
            }
        }
    }
</script>

<style lang="scss" scoped>
.el-table{
    margin-top:22px;
}
.el_s_left{
    float:left
}
.el_btn{
    clear:both;
}

.filter-item1{
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0!important;
    margin-left: 0!important;
    margin-right: 22px;
  }
  .el-radio__label{
    display:none;
  }
  .sh_tip{
      vertical-align:top;
      display:inline-block
  }
  .lf_item span:first-child{
      display:inline-block;
      width:100px;
      vertical-align:top;
  }
  .el-form-items{
    float: left;
    width: 48%!important;
  }
  .el-form-itemss{
    width: 300px!important;
    height: 40px!important;
    background-attachment: #fff!important;
  }
  .el-form-itemss .el-input{
    outline: none!important;
  }
  .el-f-item{
    width: 100%!important;
  }
  .el-dialog__header{
    margin-bottom: 0px;
  }
  .el-tag{
    border: 0!important;
    color: #666!important;
    background-color: transparent;
    font-size:14px;
  }
  .dialog-footer{
    margin-left: 0!important;
  }
  .filter-item1{
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0!important;
    margin-left: 0!important;
    margin-right: 22px;
  }

  .is-required{
    
  }
  .el-dialog__footer{
    -height:120px;
  }
  .p1{
    width:100% !important;
  }
  .part{
    position: relative;
  }
  .el-table ::v-deep .el-table__row:nth-child(even) {
    background-color: #F6F9FF !important;
  }

</style>
